const BUILD_ID = '6.0.4'
export { BUILD_ID }
